import { configureStore } from "@reduxjs/toolkit";

import reducers from "./slices/index";

const persistedState = localStorage.getItem("reduxState")
  ? JSON.parse(localStorage.getItem("reduxState") ?? "{}")
  : {};
export const setupStore = (name = "BOB Quiz") => {
  return configureStore({
    reducer: reducers,
    preloadedState: persistedState,
    devTools: {
      name,
      maxAge: 40,
      latency: 1000,
    },
  });
};
const store = setupStore();
store.subscribe(() =>
  localStorage.setItem("reduxState", JSON.stringify(store.getState()))
);
export type RootState = ReturnType<typeof store.getState>;

export default store;
